import React from 'react';
import PropTypes from 'prop-types';
import { colours } from '../helpers';
import { usePromiseTracker } from 'react-promise-tracker';
import Loader from 'react-loader-spinner';

const DataSpinnerComponent = ({
  spinnerType,
  color,
  height,
  width,
  timeout
}) => {
  const { promiseInProgress } = usePromiseTracker();
  return (
    <Loader
      type={spinnerType}
      color={color || colours.colours.black}
      height={height || 100}
      width={width || 100}
      timeout={timeout || 0}
      visible={promiseInProgress}
    />
  );
};

DataSpinnerComponent.propTypes = {
  spinnerType: PropTypes.string.isRequired,
  color: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
  timeout: PropTypes.number
};

export default DataSpinnerComponent;


// WEBPACK FOOTER //
// src/Components/DataSpinnerComponent.jsx